<svelte:options customElement="clw-icon-close" />

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2092_120370)">
        <path
            d="M19.8386 6.18445C20.3851 5.63792 20.3842 4.75084 19.8403 4.20693L19.7929 4.15951C19.2472 3.61389 18.3636 3.61287 17.8153 4.16117L12.2578 9.71868C12.1151 9.86143 11.8812 9.85903 11.7409 9.71868L6.18335 4.16117C5.63682 3.61464 4.74974 3.6156 4.20583 4.15951L4.15841 4.20693C3.61279 4.75255 3.61177 5.63615 4.16007 6.18445L9.71758 11.742C9.86034 11.8847 9.85794 12.1186 9.71758 12.2589L4.16007 17.8164C3.61354 18.363 3.6145 19.25 4.15841 19.7939L4.20583 19.8414C4.75145 20.387 5.63505 20.388 6.18335 19.8397L11.7409 14.2822C11.8836 14.1394 12.1175 14.1418 12.2578 14.2822L17.8153 19.8397C18.3619 20.3862 19.2489 20.3853 19.7929 19.8414L19.8403 19.7939C20.3859 19.2483 20.3869 18.3647 19.8386 17.8164L14.2811 12.2589C14.1383 12.1162 14.1407 11.8823 14.2811 11.742L19.8386 6.18445Z"
            fill="white"
        />
    </g>
    <defs>
        <clipPath id="clip0_2092_120370">
            <rect width="16.5" height="16.5" fill="white" transform="translate(3.75 3.75)" />
        </clipPath>
    </defs>
</svg>
